import { useEffect } from 'react';
import { autorun } from 'mobx';
import { useLDClient, withLDProvider } from 'launchdarkly-react-client-sdk';
import { useAuth0 } from '@auth0/auth0-react';

const LaunchDarkly = ({ children }) => {
  const ldClient = useLDClient();
  const { user } = useAuth0();

  useEffect(() => {
    return autorun(async () => {
      const tenantId = user && user[process.env.NEXT_PUBLIC_AUTH0_TENANT_CLAIM];
      const metadata =
        user && user[process.env.NEXT_PUBLIC_AUTH0_METADATA_CLAIM];
      if (ldClient && tenantId) {
        await ldClient.identify({
          key: tenantId,
          email: user.email,
          firstName: metadata.firstname,
          lastName: metadata.lastname,
        });
      }
    });
  });

  return children;
};

export default withLDProvider({
  clientSideID: process.env.NEXT_PUBLIC_LAUNCH_DARKLY_ID,
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
})(LaunchDarkly);
